<div class="raised-btn btn-with-theme" [ngClass]="theme">
    <button mat-raised-button
    class="btn"
    [type]="type"
    [ngClass]="{'uc': uppercase}"
    [color]="color"
    [disabled]="disabled"
    [ngStyle]="{'fontWeight': fontWeight}">
      <div class="mdc-button-flex">
        {{text}}
        <div class="triangle"></div>
      </div>
    </button>
</div>
